import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { NumericExpressionModule } from 'app/shared/directives/numeric-expression/numeric-expression.module';
import { DynamicControlComponent } from 'app/modules/dossier-area/components/dynamic-control/dynamic-control.component';
import { RangeFieldModule } from 'app/shared/components/range-field/range-field.module';
import { ComboboxModule } from 'app/shared/directives/combobox/combobox.module';
import { ApiServerUrlPipeModule } from 'app/shared/pipes/api-server-url.pipe.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RangeFieldModule,
    TextBoxModule,
    NumericExpressionModule,
    TranslateModule,
    ComboboxModule,
    ApiServerUrlPipeModule
  ],
  declarations: [DynamicControlComponent],
  exports: [DynamicControlComponent],
})
export class DynamicControlModule {}
